import {ACTIVITY_TYPE} from './activity-type/activity-type.data';
import {AGE} from './age/age.data';
import {CONTRIBUTION_TYPE} from './contribution-types/contribution-types.data';
import {COUNTY} from './county/county.data';
import {DISPUTE_TYPES} from './dispute-type/dispute-type.data';
import {EDUCATION} from './education/education.data';
import {GENDER} from './gender/gender.data';
import {
    CIRCLE_TYPE,
    CONTINUING_EDUCATION_TYPES,
    COURT_REFERRAL_EVENTS,
    COURT_REFERRAL_SOURCE,
    FORMATS,
    MEDIUMS,
    RENTAL_ASSISTANCE_TYPES,
    SUBSIDY_TYPES,
} from './general/general.data';
import {GRANT_STATUS} from './grant-status/grant-status.data';
import {INCOME} from './income/income.data';
import {LANGUAGE} from './language/language.data';
import {PAYMENT_STATUS, PAYMENT_TYPE, REDUCTION_TYPE} from './payment-type/payment-type.data';
import {RACE} from './race/race.data';
import {RATE_TYPE} from './rate-types/rate-types.data';
import {REFERAL_MEDIUMS} from './referral-mediums/referral-mediums.data';
import {STATE} from './states/state.data';
import {STEP_INTERPRETER_TYPE, STEP_STATUS, STEPS} from './step/step.data';
import {SURVEY_AUDIENCE_TYPE} from './survey-audience-type/survey-audience-type.data';
import {APPROVAL_STATUS} from './system/approval-status.data';
import {COMMUNITY_REPRESENTATION} from './system/community-representaion.data';
import {COURT_DEPARTMENTS} from './system/court-departments.data';
import {ENTITY_TYPES} from './system/entity-type.data';
import {RELATIONSHIP_TO_CENTER} from './system/relationship-to-center.data';
import {TENANCY_PARTICIPANT_TYPE} from './system/tenancy-participant-type.data';
import {VALID_PERIOD, VOLUNTEER_ORIENTATION_STATUS} from './system/valid-period.data';
import {USER_ROLE} from './user-roles/user-roles.data';

export const MASTERDATA = [
    STATE,
    COUNTY,
    AGE,
    GENDER,
    RACE,
    ACTIVITY_TYPE,
    ...DISPUTE_TYPES,
    STEPS,
    STEP_INTERPRETER_TYPE,
    STEP_STATUS,
    LANGUAGE,
    EDUCATION,
    ENTITY_TYPES,
    GRANT_STATUS,
    RELATIONSHIP_TO_CENTER,
    COURT_DEPARTMENTS,
    APPROVAL_STATUS,
    INCOME,
    USER_ROLE,
    RATE_TYPE,
    CONTRIBUTION_TYPE,
    PAYMENT_STATUS,
    PAYMENT_TYPE,
    REDUCTION_TYPE,
    TENANCY_PARTICIPANT_TYPE,
    VALID_PERIOD,
    VOLUNTEER_ORIENTATION_STATUS,
    SURVEY_AUDIENCE_TYPE,
    // ----------- General ------------
    SUBSIDY_TYPES,
    RENTAL_ASSISTANCE_TYPES,
    CIRCLE_TYPE,
    FORMATS,
    CONTINUING_EDUCATION_TYPES,
    COURT_REFERRAL_EVENTS,
    COURT_REFERRAL_SOURCE,
    MEDIUMS,
    REFERAL_MEDIUMS,
    COMMUNITY_REPRESENTATION,
];
